import React, { useEffect, useRef } from "react";
import "./necklacesShop.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ShopIcon from "../../../images/shop.svg";
import Necklace_1 from "./images/necklace_1.webp";
import Necklace_2 from "./images/necklace_2.webp";
import Necklace_3 from "./images/necklace_3.webp";
import Necklace_4 from "./images/necklace_4.webp";
import Necklace_5 from "./images/necklace_5.webp";
import Video1 from "./images/video_1.mp4";

export default function NecklacesShop() {
  return (
    <div className="necklacesShop-main">
      <div className="necklacesShop-container">
        <video
          playsinline="true"
          autoplay="true"
          loop="true"
          muted="true"
          className="necklacesShop-element necklacesShop-video"
        >
          <source
            src={
              "https://cdn.media.amplience.net/v/teilor/Natalia site patrat 3/mp4_720p"
            }
            type="video/mp4"
          />
        </video>
        <div className="necklacesShop-element necklacesShop-product-1">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/naszyjnik-tenisowy-z-bialego-zlota-18-karatowego-z-diamentami-8-6ct-106133.html"
          >
            <img
              className="zoom"
              alt=""
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/naszyjnik-tenisowy-z-biaego-zota-18karatowego-z-diamentami-86ct_3111044_1_1653919976.png"
              }
            />
            <img className="shop-icon" alt="" src={ShopIcon} />
          </a>
        </div>
        <div className="necklacesShop-element necklacesShop-product-2">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/naszyjnik-z-bialego-zlota-18-karatowego-z-czarnymi-diamentami-1-63ct-i-diamentami-1-17ct-121738.html"
          >
            <img
              className="zoom"
              alt=""
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/naszyjnik-z-biaego-zota-18karatowego-z-czarnymi-diamentami-163ct-i-diamentami-117ct_3115128_1_1653919977.png"
              }
            />
            <img className="shop-icon" alt="" src={ShopIcon} />
          </a>
        </div>
        <div className="necklacesShop-element necklacesShop-product-3">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/naszyjnik-z-bialego-18k-zlota-z-diamenty-3-41ct-108373.html"
          >
            <img
              className="zoom"
              alt=""
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/naszyjnik-z-biaego-18k-zota-z-diamenty-341ct_2489440_1_1647347806.png"
              }
            />
            <img className="shop-icon" alt="" src={ShopIcon} />
          </a>
        </div>
        <div className="necklacesShop-element necklacesShop-product-4">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/naszyjnik-z-bialego-14k-zlota-z-brylantami-1-46ct-122263.html "
          >
            <img
              className="zoom"
              alt=""
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/naszyjnik-z-biaego-14k-zota-z-brylantami-146ct_3098462_1_1653917619.png"
              }
            />
            <img className="shop-icon" alt="" src={ShopIcon} />
          </a>
        </div>
        <div className="necklacesShop-element necklacesShop-product-5">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/naszyjnik-z-bialego-18k-zlota-z-diamenty-3-48ct-108350.html "
          >
            <img
              className="zoom"
              alt=""
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/naszyjnik-z-biaego-18k-zota-z-diamenty-348ct_2489420_1_1647347806.png"
              }
            />
            <img className="shop-icon" alt="" src={ShopIcon} />
          </a>
        </div>
      </div>
      <div className="component-button">
        <div className="component-button-border"></div>
        <div className="component-button-text">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/pure-diamonds/filtre/rodzaj-bizuterii-naszyjnik.html"
          >
            ODKRYJ NASZYJNIKI
          </a>
        </div>
      </div>
    </div>
  );
}
